import queryString from 'query-string';
import { AboFilterI } from 'src/adminPanel/components/pages/office/AboSubscriptionFilter';
import AboSubscription from 'src/adminPanel/entities/office/subscriptions/AboSubscription';
import callApi, { CallApiResult } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export const retrieveAboTemplatesByCustomerId = (
    identifier: string,
    pageable: PageableQueryParams
): Promise<CallApiResult> => {
    let query = queryString.stringify({ identifier, ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== undefined && query !== '') query = '?' + query;
    const endpoint = `/api/subscription/byCustomerId${query}`;
    return callApi(endpoint);
};

export const retrieveAboTemplatesByFilter = (
    pageable: PageableQueryParams,
    filter: AboFilterI
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== undefined && query !== '') query = '?' + query;
    const endpoint = `/api/subscription/byFilter${query}`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

export const retrieveAboTemplateById = (templateId: string) => {
    const endpoint = `/api/subscription/${templateId}`;
    return callApi(endpoint);
};

export const retrieveAboSubscriptionOrderProducts = () => {
    const endpoint = '/api/subscription/subscription/orderProducts';
    return callApi(endpoint);
};

export const saveAboSubscription = (aboSubscription: AboSubscription) => {
    const endpoint = '/api/subscription/add';
    return callApi(endpoint, { method: 'POST', data: aboSubscription });
};

export const amendAboSubscription = (aboSubscription: AboSubscription) => {
    const endpoint = '/api/subscription/update';
    return callApi(endpoint, { method: 'PUT', data: aboSubscription });
};
